module.exports = {"apiKey":"AIzaSyCUD4EH9q-8V8bMr6kHPsUDQ6POpGTHk0M","authDomain":"cancer-sucks.firebaseapp.com","databaseURL":"https://cancer-sucks.firebaseio.com","projectId":"cancer-sucks","storageBucket":"cancer-sucks.appspot.com","messagingSenderId":"935142913902"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase-config.json
// module id = Kufx
// module chunks = 1